module.exports = __webpack_public_path__ + "assets/estudi-min.ceaecc648a4124d8381517636eca7d37.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/WuikStudio/estudi-min.jpg
 ** module id = 405
 ** module chunks = 0
 **/